// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.freemium.RentalManagerUserFreemiumWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  FreemiumChargeResponseWebDto,
  FreemiumDetailsResponseWebDto,
  FreemiumStartPaymentMethodSessionResponseWebDto,
  ListingAlias,
  RentalManagerPaymentProductType,
} from '../..';

interface ChargeParams {
  hostApp?: string;
  listingAlias: ListingAlias;
  productType: RentalManagerPaymentProductType;
}
interface DetailsParams {
  listingAlias: ListingAlias;
}
interface StartPaymentMethodSessionParams {
  hostApp?: string;
  listingAlias: ListingAlias;
}

export const RentalManagerUserFreemiumWebApiHandler_charge_Path = '/api/web/v1/users/freemium/charge';

/**
 * Charge credit card
 */
export const RentalManagerUserFreemiumWebApiHandler_charge = (getParams: ChargeParams, client = getClient()) => {
  return httpFrontEndRequest<ChargeParams, never, FreemiumChargeResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumWebApiHandler_charge_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumWebApiHandler_details_Path = '/api/web/v1/users/freemium/details';

/**
 * Get freemium details for a listing
 */
export const RentalManagerUserFreemiumWebApiHandler_details = (getParams: DetailsParams, client = getClient()) => {
  return httpFrontEndRequest<DetailsParams, never, FreemiumDetailsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Path =
  '/api/web/v1/users/freemium/isTopOfFunnelEnrollmentEligible';

/**
 * Get user's eligibility for top of funnel enrollment
 */
export const RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible = (client = getClient()) => {
  return httpFrontEndRequest<never, never, boolean>(
    {
      endpoint: RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession_Path =
  '/api/web/v1/users/freemium/startPaymentMethodSession';

/**
 * Start payment method session to load the credit card iframe
 */
export const RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession = (
  getParams: StartPaymentMethodSessionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<StartPaymentMethodSessionParams, never, FreemiumStartPaymentMethodSessionResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
